
class StringCache {
  private expires: number = NaN;
  private value: string | null = null;

  constructor(private maxAgeMs: number) {
  }

  getNonexpired(now: number): string | null {
    if (this.value == null || now > this.expires) {
      return null;
    }
    return this.value;
  }
  putFresh(now: number, freshJwt: string) {
    this.expires = now + this.maxAgeMs;
    this.value = freshJwt;
  }
}

/**
 * TODO: Unify freshness evaluation with matching code in Mimir.ts from branch
 * prepare-for-api-keys-in-kelda once merged.
 */
export function makeJwtCache(): StringCache {
  return new StringCache(30 * 60 * 1000);
}
